import { UseRecordsOptions } from "../../api/useRecords";
import { RecordContextType } from "../../components/record/Record";

export const categoriesChildOptions = {
  fieldsToRemove: {
    fieldTypesToRemove: ["alias"],
    fieldNamesToRemove: ["id"],
  },
  groupsOptions: {
    fieldsWithExtraOptions: [
      {
        field: "process_parent_category",
        enabled: true,
      },
    ],
  },
  createRelatedParams: (params: RecordContextType | undefined) => createProcessParams(params),
} as unknown as UseRecordsOptions;

const createProcessParams = async (recordContext: RecordContextType | undefined) => {
  if (!recordContext?.item) return;
  if (recordContext.entity === "processes_parent_category") {
    return `[processes_parent_category][id]=${recordContext.item.id}`;
  }
};
